<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M14.94 3.48l-9 5.6a2 2 0 00-.94 1.7v10.44a2 2 0 00.94 1.7l9 5.6a2 2 0 002.12 0l9-5.6a2 2 0 00.94-1.7V10.78a2 2 0 00-.94-1.7l-9-5.6a2 2 0 00-2.12 0zm9.17 6.75l-8.11 5-8.11-5L16 5.18zM7 12l8 5v9.2l-8-5zm10 14.2V17l8-5v9.19z"/></svg>